import UnlockIcon from '@assets/icons/UnlockIcon'
import { tabletQuery } from '@globals/themes/themeConstants'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { T, useT } from '@transifex/react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

type PublicPrivateFieldProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
}

const PublicPrivateField = <T extends FieldValues>({
  control,
  name,
}: PublicPrivateFieldProps<T>) => {
  const t = useT()
  const isTablet = useMediaQuery(tabletQuery)

  const {
    field: { value, onChange },
  } = useController({ control, name })

  const buttonText = () => {
    if (isTablet) {
      return value ? <T _str="Public" /> : <T _str="Private" />
    }
    return value ? <T _str="This post is public" /> : <T _str="This post is private" />
  }

  return (
    <>
      <Button
        variant="text"
        id="btnPublicPrivate"
        sx={{ mt: 2 }}
        onClick={() => onChange(!value)}
        aria-label={value ? t('Set to private') : t('Set to public')}
        startIcon={value ? <UnlockIcon /> : <LockOutlinedIcon />}>
        {buttonText()}
      </Button>
      <Typography variant="body1"></Typography>
    </>
  )
}

export default PublicPrivateField
